// extracted by mini-css-extract-plugin
var _1 = "gftnuFTwFKqNDir74HSC";
var _2 = "R57x8nfr4AyxxkJNvE2O";
export { _1 as "button", _2 as "leftbutton" }
